/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PracticeTypeModel } from '../../models/practice-type-model';

export interface PracticeTypeIdGet$Params {
  id: string;
}

export function practiceTypeIdGet(http: HttpClient, rootUrl: string, params: PracticeTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PracticeTypeModel>> {
  const rb = new RequestBuilder(rootUrl, practiceTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<PracticeTypeModel>;
    })
  );
}

practiceTypeIdGet.PATH = '/PracticeType/{id}';
